import { i18nMark } from 'lingui-react';

const messages = {
  breadcrumbs: i18nMark('Case {number}'),
  description: i18nMark('The case page of the application'),
  title: i18nMark('The Case Page'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/CaseDetailData/messages.js